/* The product gallery's thumbnails switch the main photograph. They used to be static divs — the
   drawn page had no interaction and the port kept it that way — until the client clicked one and
   nothing happened ("changing product picture, doesn't work", 2026-10-01). The thumbs are real
   buttons now (product-buy.liquid), each carrying its own full-size image and alt in data
   attributes, so the swap needs no fetch and no network round trip.

   Without JavaScript the thumbs are inert buttons and the first image stands — the page reads
   exactly as it did before this file existed. */
(() => {
  const galleries = [...document.querySelectorAll('.v2-gallery')];
  if (!galleries.length) return;
  for (const gallery of galleries) {
    /* The first frame is the one that must move: only the main image, never the thumbs. */
    const main = gallery.querySelector('.v2-gallery__main img');
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    if (!main || thumbs.length < 2) continue;
    for (const thumb of thumbs) {
      thumb.addEventListener('click', () => {
        const src = thumb.getAttribute('data-src');
        if (!src) return;
        main.src = src;
        const srcset = thumb.getAttribute('data-srcset');
        if (srcset) main.srcset = srcset;
        const alt = thumb.getAttribute('data-alt');
        if (alt) main.alt = alt;
        for (const other of thumbs) {
          const on = other === thumb;
          other.classList.toggle('v2-thumb--on', on);
          if (on) other.setAttribute('aria-current', 'true');
          else other.removeAttribute('aria-current');
        }
      });
    }
  }
})();
